import {LocalizedDictionary} from '../Translator';

export default {
  "DD": "DD",
  "Discontinued": "중단됨",
  "Spare part list": "예비 부품 목록",
  "Download Excel": "Excel 다운로드",
  "Recent search list": "최근 검색 목록",
  "No data": "데이터 없음",
  "spare part": "예비 부품",
  "none": "없음",
  "no value": "가치 없음",
  "No results found": "결과를 찾을 수 없습니다.",
  "Spare parts for": "다음용 예비 부품",
  "Could not load cumulated data": "누적된 데이터를 로드할 수 없습니다.",
  "commissioning part": "커미셔닝 부분",
  "wear part": "마모 부품",
  "Search": "검색",
  "Tk": "Tk",
  "Spare part number": "예비 부품 번호",
  "drawing": "그리기",
  "Products for": "대상 제품",
  "Available": "사용 가능",
  "MM": "MM",
  "The entered order code is invalid": "입력한 주문 코드가 유효하지 않습니다.",
  "Recommended": "추천",
  "No data available for the entered search parameters": "입력한 검색 매개변수에 사용할 수 있는 데이터가 없습니다.",
  "Search spare parts": "예비 부품 검색",
  "Order code / product root / serial number": "주문 코드/제품 루트/일련 번호",
  "Characteristic": "특징",
  "Please enter an order code": "주문 코드를 입력하세요.",
  "Regarding quality- and security-aspects Endress+Hauser strongly recommends the exclusive use of genuine Endress+Hauser spare parts. The instrument may only be maintained and repaired by qualified personnel. The device documentation, applicable standards and legal requirements as well as any certificates have to be observed!": "품질 및 보안 측면과 관련하여 엔드레스하우저는 엔드레스하우저 순정 예비 부품의 사용을 강력히 권장합니다. \n계측기는 자격을 갖춘 직원만 유지 관리 및 수리할 수 있습니다. \n장치 문서에 적용되는 표준 및 법적 요구 사항과 모든 인증서를 준수해야 합니다!",
  "Maintenance advice": "유지 관리 조언",
  "Mo.": "Mo.",
  "For which product(s) can my spare part be used? Filling in the spare part order code (e.g. 71002865 or XPD0024) shows the relevant devices this spare part can be used in.": "예비 부품은 어떤 제품에 사용할 수 있나요? 예비 부품 주문 코드(예: 71002865 또는 XPD0024)를 입력하면 이 예비 부품을 사용할 수 있는 관련 디바이스를 확인할 수 있습니다.",
  "tool": "도구",
  "Production numbers": "생산 번호",
  "New alternative": "새로운 대안",
  "There are no items selected. Please use the checkboxes to make your selection": "선택한 항목이 없습니다. 확인란을 사용하여 선택해 주세요.",
  "Service segmentation": "서비스 세분화",
  "Seg": "Seg",
  "Valid": "유효",
  "Pos": "Pos",
  "Value": "가치",
  "service segmentation 2": "기본 지식이 필요한 부분. E+H 기본 교육에 성공적으로 참여하는 것이 전제 조건입니다.",
  "Phase out date": "단계적 폐지 날짜",
  "service segmentation 1": "기본 지식이 필요한 부분.",
  "Which spare parts are available for my product? Filling in the order code (e.g. FTC260-AA2A1 or PMC51-BA21JB1CGBTDJB) or the product id (e.g. FTC260 or 83F50) shows the relevant spare parts.": "내 제품에 어떤 예비 부품을 사용할 수 있나요? 주문 코드(예: FTC260-AA2A1 또는 PMC51-BA21JB1CGBTDJB) 또는 제품 ID(예: FTC260 또는 83F50)를 입력하면 관련 예비 부품을 확인할 수 있습니다.",
  "Set filter": "필터 설정",
  "Search date": "검색 날짜",
  "Group": "그룹",
  "Warning": "경고",
  "Description": "설명",
  "Cancel": "취소",
  "service segmentation 4": "공장에서 수리할 부품입니다. 전문 지식은 필수입니다.",
  "service segmentation 3": "전문 지식이 필요한 부분. E+H 고급 교육에 성공적으로 참여하는 것이 전제 조건입니다.",
  "Drawing Position Number": "그리기 위치 번호",
  "Spare parts search": "예비 부품 검색",
  "Confirm": "확인",
  "Ordercode too short": "주문 코드가 너무 짧습니다.",
  "Product status": "제품 상태",
  "Open": "열기",
  "Clear": "지우기",
  "PDF file with assembly instructions": "조립 설명서가 포함된 PDF 파일",
  "Search products": "제품 검색",
  "Export": "내보내기",
  "Production date": "생산 날짜",
  "Order stop": "주문 중지",
  "Calibration until": "다음까지 보정",
  "PDF file with compatibility information": "호환성 정보가 포함된 PDF 파일",
  "Add selection to cart": "장바구니에 선택 항목 추가",
  "Mounting advices": "마운팅 조언",
  "Recommended parts only": "권장 부품만",
  "not applicable": "해당 없음",
  "accessories": "액세서리",
  "Cumulative spare parts list": "누적 예비 부품 목록",
  "YYYY": "YYYY",
  "Title": "제목",
  "Error": "오류",
  "Ordercode too long": "주문 코드가 너무 깁니다.",
  "Functions": "기능",
  "Rec": "Rec",
  "Type": "유형",
  "Spare sensor until": "다음까지 예비 센서",
  "Spare parts until": "다음까지 예비 부품",
  "Filter": "필터",
  "Check all": "모두 확인",
  "Order code": "주문 코드",
  "Repair until": "다음까지 수리",
  "Tag": "태그",
  "Ok": "확인",
  "Category code": "카테고리 코드",
  "Phase out": "단계적 폐지",
  'Compatibility advices': '추가 문서',
  'Co.': '추가 문서',
} as LocalizedDictionary;
